<template>
  <section class="section">
    <div class="container mt-5">
      <div class="row">
        <div
          class="col-12 col-sm-8 offset-sm-2 col-md-6 offset-md-3 col-lg-6 offset-lg-3 col-xl-4 offset-xl-4"
        >
          <div class="login-brand">
            <img
              :src="$helper.getFile('9f89c84a559f573636a47ff8daed0d33')"
              alt="logo"
              width="250"
            />
            <!-- class="shadow-light" -->
          </div>

          <div class="card card-primary">
            <div class="card-header">
              <h4>Login</h4>
            </div>

            <div class="card-body">
              <form class="login-form needs-validation" novalidate>
                <!-- <% if (!String.IsNullOrEmpty(this.lbl_status.Text))
                                    { %>
                                <div class="form-group">
                                    <div class="alert alert-danger alert-has-icon">
                                        <div class="alert-icon"><i class="far fa-lightbulb"></i></div>
                                        <div class="alert-body">
                                            <asp:Label ID="lbl_status"  />
                                        </div>
                                    </div>
                                </div>
                <% } %>-->

                <div class="form-group" >
                  <label for="txtUsername">Username</label>

                  <input
                    ref="txtUsername"
                    id="txtUsername"
                    type="text"
                    class="form-control"
                    name="txtUsername"
                    v-model="username"
                    tabindex="1"
                    required
                    autofocus
                  />
                  <div class="errormsg" v-if="usernamenull">Please fill in your username</div>
                </div>

                <div class="form-group">
                  <div class="d-block">
                    <label for="txtPassword" class="control-label">Password</label>
                    <div class="float-right">
                      <a href="ResetPassword.aspx" class="text-small">Change Password</a>
                    </div>
                  </div>

                  <input
                    ref="txtPassword"
                    id="txtPassword"
                    type="password"
                    class="form-control"
                    v-model="password"
                    name="txtPassword"
                    tabindex="2"
                    required
                  />
                  <div class="errormsg" v-if="passwordnull">please fill in your password</div>
                  <div class="errormsg" v-if="wrongpassword">{{msg}}</div>
                </div>

                <div class="form-group" >
                  <div class="custom-control custom-checkbox">
                    <input
                      type="checkbox"
                      name="remember"
                      class="custom-control-input"
                      tabindex="3"
                      id="remember-me"
                    />
                    <label class="custom-control-label" for="remember-me">Remember Me</label>
                  </div>
                </div>

                <div class="form-group">
                  <button
                    :disabled="processing"
                    @click="loginClicked"
                    type="button"
                    class="btn btn-primary btn-lg btn-block"
                    tabindex="4"
                  >Login</button>
                </div>
                <!-- <button
                  @click="emailLoginClicked"
                  type="button"
                  class="btn btn-primary btn-lg btn-block"
                  tabindex="4"
                ><i class="fab fa-windows" style="font-weight: normal; padding-right: 6px;"></i>Azure AD Login</button> -->

              </form>
            </div>
          </div>
          <div class="simple-footer"><img src="static/img/lswork.png" alt="lswork" width="40">&nbsp;Powered by © Cloris Cheung Consultant Company 2026</div>
          <div class="simple-footer">
            Environment&nbsp;&nbsp;{{ systemVersion }}
            <!-- <%=WebApp.MXConstant.MXVERSION %> -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from "@/config.js";
import api from "@/api.js";
import { mapActions } from "vuex";
import helper from "@/vueHelper";
// import store from '@/store/index'

export default {
  name: "login",
  data() {
    return {
      publicPath: process.env.BASE_URL,
      username: "",
      password: "",
      msg: "",
      passwordnull: false,
      usernamenull: false,
      wrongpassword:false,
      processing: false,
      submitted: false,
      systemVersion: config.systemVersion,
      sidLogin:null
    };
  },
  beforeMount() {
    if (this.$store.state.token) {
      this.$router.replace('/')
    }
    else if(config.authMethod == 'AD') { //remember to match the API config with this config

    }
  },
  mounted() {
    if (this.$store.state.token) {
      this.$router.replace('/')
    }
    else if(this.$msal&&this.$msal.isAuthenticated()) { //remember to match the API config with this config
      helper.loading();

      api.request(this, 'post', '/system/authenticate', {
        SessionID: null,
        LocaleCode: config.defaultLocale,
        Parameters: {
          method: "AD",
          username: this.$msal.data.user.userName,
          password:'',
          isAuthenticated:this.$msal.isAuthenticated()
        }
      }, function (r) {
        this.loginSuccess(r)
        helper.done();
      }, function (r) {
        this.loginFail(r)
        helper.done();
      })
    }
    else {
      if (this.$route.query.sid) {
        this.sidLogin = true;

        api.request(
          this,
          "post",
          "/system/authenticate",
          {
            SessionID: this.$route.query.sid,
            LocaleCode: config.defaultLocale,
            Parameters: {
              method: "SID"
            }
          },
          function(r) {
            this.loginSuccess(r);
          },
          function(r) {
            this.message = r.response.data.Message;
            this.sidLogin = false;
            this.processing = false;
          }
        );
      } else if (this.$route.query.user) {
        this.username = this.$route.query.user;

        this.$refs.txtPassword.focus();
      } else {
        this.$refs.txtUsername.focus();
      }

      $(".login-form input").on(
        "keypress",
        $.proxy(function(e) {
          var keycode = e.keyCode ? e.keyCode : e.which;
          if (keycode === 13) {
            this.loginClicked();
          }
        }, this)
      );
    }
  },
  components: {},
  methods: {
    ...mapActions(["actionSetToken", "actionSetMessage", "actionSetUser","actionSetSidLogin"]),
    loginClicked() {
      this.processing = true;
      this.submitted = true;

      // Validate form
      if (!this.username) {
        this.processing = false;
        this.$refs.txtUsername.focus();
        this.usernamenull=true;
      } else if (!this.password) {
        this.processing = false;
        this.$refs.txtPassword.focus();
        this.passwordnull=true;
      } else {
        api.request(
          this,
          "post",
          "/system/authenticate",
          {
            SessionID: null,
            LocaleCode: config.defaultLocale,
            Parameters: {
              method: config.authMethod,
              username: this.username,
              password: this.password
            }
          },
          function(r) {
            this.loginSuccess(r);
          },
          function(r) {
            this.loginFail(r);
          }
        );
      }
    },
    emailLoginClicked(){
      if (!this.$msal.isAuthenticated()) {
        this.$msal.signIn();
      }
    },
    loginSuccess(r) {
      console.log(r );
      if (r.code === 200) {
        console.log(r.data.user_profile)
        this.actionSetUser(r.data.user_profile);
        this.actionSetToken(r.data.session_id);
        this.actionSetSidLogin(this.sidLogin);
        console.log(r.data.session_id);
        // Support refresh
        helper.lsstore = null;
        helper.getConfig();
        if (window.localStorage) {
          // window.localStorage.setItem(
          //   "ccrs_user",
          //   JSON.stringify(r.data.user_profile)
          // );
          // window.localStorage.setItem("ccrs_token", r.data.session_id);
        }

        if (this.$route.query.redirect) {
          this.$router.replace(this.$route.query.redirect);
        } else {
          this.$router.replace("/Inbox");
        }
        // this.$router.go(0);
      } else {
        this.message = r.message;
        this.msg = this.message;
        this.wrongpassword=true;
        this.afterLoginFail();
      }
    },
    loginFail(r) {
      this.message = r.response.data.Message;

      this.afterLoginFail();
    },
    afterLoginFail() {
      this.sidLogin = false;
      this.processing = false;

      var p = this;

      window.setTimeout(function() {
        if (!p.username) {
          p.$refs.txtUsername.focus();
        } else if (!p.password) {
          p.$refs.txtPassword.focus();
        } else {
          p.$refs.txtUsername.focus();
        }
      }, 200);
    }
  }
};
</script>
<style>
.errormsg {
  width: 100%;
    margin-top: .25rem;
    font-size: 80%;
    color: #dc3545;
}
</style>
